












































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYearTable_rows,
  GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksNotInYearPaidInYearTable_rows,
  GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYearTable_footer,
  GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksNotInYearPaidInYearTable_footer,
} from '@/queries/__generated__/ameldingAndBookkeepingReconciliationReport';
import { workRelationDisplay } from '@/app/WorkRelation';

type Row = GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYearTable_rows | GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksNotInYearPaidInYearTable_rows;

type Footer = GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYearTable_footer | GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_paychecksNotInYearPaidInYearTable_footer;

@Component({})
export default class PaidPaychecks extends Vue {
  @Prop({ required: true }) private headers!: string[];
  @Prop({ required: true }) private rows!: Row[];
  @Prop({ required: true }) private footer!: Footer;
  private workRelationDisplay = workRelationDisplay;
}
